// Capture DETERRENTS - friction, not prevention, and always on. A web app cannot stop a
// screenshot; these raise the bar. Documented as best-effort in SECURITY.md.

/** Blur message content when the tab is hidden or loses focus. */
function onVisibility(): void {
  const hide = document.hidden || !document.hasFocus();
  document.body.classList.toggle("screen-hidden", hide);
}

/** Discourage casual copy / native context-menu / drag on message content. */
function block(e: Event): void {
  const target = e.target as HTMLElement | null;
  if (target?.closest(".no-capture")) e.preventDefault();
}

export function initDeterrents(): void {
  document.addEventListener("visibilitychange", onVisibility);
  window.addEventListener("blur", onVisibility);
  window.addEventListener("focus", onVisibility);
  for (const evt of ["copy", "contextmenu", "dragstart", "cut"]) document.addEventListener(evt, block);
  onVisibility();
}
